import Route from './HomeRoute';
import HomeLink from './HomeLink';
export default Route;
export { HomeLink };
